import type { ReactNode } from 'react';
import { KeyboardShortcutKey } from '@/components/ui/KeyboardShortcutKey';
import { cva, cx, type VariantProps } from '@/cva.config';

const sectionHeaderVariants = cva({
  base: 'font-mono text-2xs lg:text-xs font-medium tracking-[0.12em] text-foreground-muted uppercase',
  defaultVariants: {
    size: 'md',
  },
  variants: {
    size: {
      lg: 'text-base lg:text-lg',
      md: 'text-sm lg:text-base',
      sm: 'text-sm lg:text-base',
      xs: 'text-xs lg:text-sm',
    },
  },
});

interface SectionHeaderProps
  extends VariantProps<typeof sectionHeaderVariants> {
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  kbd?: string;
}

export const SectionHeader = ({
  action,
  children,
  className,
  kbd,
  size,
}: SectionHeaderProps) => (
  <div className={cx('mb-3 flex items-center justify-between', className)}>
    <h2 className={sectionHeaderVariants({ size })}>{children}</h2>
    <div className="flex items-center gap-2">
      {action}
      {kbd && <KeyboardShortcutKey>{kbd}</KeyboardShortcutKey>}
    </div>
  </div>
);
